import React from "react";

import { st, FormMessage, FormControl, Button, ProductVariantFullDecorator, CouponCodeDecorator } from "lib/index";
import CouponCodeFormSection from "./CouponCodeFormSection";

export default class ProductVariantCouponCodesFormSection extends React.PureComponent {
  state = {
    newCc: CouponCodeDecorator.build({ _new: true }),
  };

  handleCouponCodeAdd(attributes = {}) {
    const { product_variant, onChange } = this.props;
    const newCc = CouponCodeDecorator.build({
      _focus: true,
      ...attributes,
    });
    onChange({
      ...product_variant,
      coupon_codes: product_variant.coupon_codes.concat([newCc]),
    });
  }

  handleCouponCodeChange(nextCc) {
    const { product_variant, onChange } = this.props;
    if (nextCc._new) {
      this.setState({ newCc: CouponCodeDecorator.build({ _new: true }) });
      this.handleCouponCodeAdd({ ...nextCc, _new: undefined });
    } else {
      onChange({
        ...product_variant,
        coupon_codes: product_variant.coupon_codes.map((x) => (x.uuid === nextCc.uuid ? nextCc : x)),
      });
    }
  }

  handleCouponCodeRemove(cc) {
    const { product_variant, onChange, onBlur } = this.props;
    onChange({
      ...product_variant,
      coupon_codes: product_variant.coupon_codes.filter((x) => x.uuid !== cc.uuid),
    });
    onBlur();
  }

  handleGenerateCouponCodesClick() {
    const { product_variant, onChange } = this.props;
    const n = prompt("How many coupon codes do you want to generate?", 10);
    if (!n) {
      return;
    }
    const prefix = prompt(
      "Write in prefix with which all the codes should be generated (you can the leave field empty to skip the prefix)"
    );
    const codes = st.range(0, +n).map(() => {
      let code = st.generateUuid().substring(0, 6).toUpperCase();
      if (prefix) {
        code = `${prefix}-${code}`;
      }
      return code;
    });
    const newCouponCodes = codes.map((code) => CouponCodeDecorator.build({ name: code }));
    onChange({
      ...product_variant,
      coupon_codes: product_variant.coupon_codes.concat(newCouponCodes),
    });
  }

  render() {
    const { readOnlyAccess, product, product_variant, errors, name, onBlur, onChange } = this.props;
    const { newCc } = this.state;
    return (
      <div>
        {!!errors[`${name}`] && <FormMessage error={errors[`${name}`]} />}

        <div className="fields grouped">
          {product_variant.coupon_codes.concat(readOnlyAccess ? [] : [newCc]).map((cc, i) => (
            <CouponCodeFormSection
              key={cc.uuid}
              readOnlyAccess={readOnlyAccess}
              name={`${name}[${cc.uuid}]`}
              coupon_code={cc}
              errors={errors}
              onChange={this.handleCouponCodeChange.bind(this)}
              onRemove={this.handleCouponCodeRemove.bind(this, cc)}
              onBlur={onBlur}
              focus={cc._focus}
            />
          ))}

          {!readOnlyAccess && (
            <div className="field">
              <Button onClick={this.handleGenerateCouponCodesClick.bind(this, undefined)} basic color="blue">
                <i className="icon material-icons">add</i>{" "}
                {I18n.t("papp.products.EditProductView.StepPricelist.generate_coupon_codes")}
              </Button>
            </div>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/products/EditProductView/StepBookingSettings/ProductVariantCouponCodesFormSection.jsx